// * Bootstrap libraries
import Tooltip from 'bootstrap/js/dist/tooltip';


(function ($, Drupal, once, Tooltip) {
  jQuery(function () {
    initTooltips();
    initCopyToClipboard();
    initRememberMe();
    initAlert();
    initSerchAccessibility();
    initStickyAside();
    initSmoothScroll();
    initTBTabs();
    initSlickCarousel();
    initColorPalettes();
    initLottieAnimation();
  });

  function initLottieAnimation() {
    var animStartClass = "animation-started";
    var activeClass = "active";

    jQuery("[data-animation-holder]").each(function () {
      var holder = jQuery(this);
      var player = holder.find("lottie-player")[0];
      var instance;
      var btnOverlayPlay = holder.find(".btn-play-start");
      var btnPlayPause = holder.find(".lottie-play-button");
      var btnRestart = holder.find(".lottie-restart-button");
      var playerTrack = holder.find(".lottie-seeker-input");
      var playerTrackCurrent = holder.find(".seeker-current");

      player.load(jQuery(player).data("src"));
      instance = player.getLottie();

      btnOverlayPlay.on("click", function (e) {
        e.preventDefault();
        player.play();
        holder.addClass(animStartClass);
      });

      btnPlayPause.on("click", function (e) {
        e.preventDefault();
        if (btnPlayPause.hasClass(activeClass)) {
          player.pause();
        } else {
          player.play();
        }
      });

      btnRestart.on("click", function (e) {
        e.preventDefault();
        player.stop();
        player.play();
      });

      playerTrack.on("input", function () {
        player.seek(playerTrack.val() + "%");
      });

      player.addEventListener("play", function () {
        btnPlayPause.addClass(activeClass);
      });

      player.addEventListener("pause", function () {
        btnPlayPause.removeClass(activeClass);
      });

      player.addEventListener("frame", function (e) {
        playerTrack.val(e.detail.seeker + 0.4);
        playerTrackCurrent.css("width", playerTrack.val() + "%");
      });
    });
  }

  function initTooltips() {
    // var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    // var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //   return new Tooltip(tooltipTriggerEl);
    // });
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
  }

  function initColorPalettes() {
    var win = jQuery(window);
    var popupArray = [];
    var resizeFlag, timer;

    function copy(text) {
      var input = document.createElement('input');
      input.setAttribute('value', text);
      document.body.appendChild(input);
      input.select();
      var result = document.execCommand('copy');
      document.body.removeChild(input);
      return result;
    }
    function beautyColor(color) {
      return (color || "").replace(/-/gi, ".");
    }

    jQuery("[data-palette]").each(function () {
      var palette = jQuery(this);
      // var jsonClass = palette.siblings('.json-data');
      var jsonVar = jQuery(this).attr("data-id");
      var type = palette.data("palette");
      var popupData = {};
      var links = jQuery();
      var cyclinders = jQuery();
      var classDisabled = "disabled";
      var classActive = "active";
      var paletteObj = {};

      paletteObj.reposition = function () {
        paletteObj.popup.removeClass(["left-placement", "right-placement"]);

        var paletteWidth = paletteObj.palette.innerWidth();
        var paletteLeft = paletteObj.palette.offset().left;
        var popupWidth = paletteObj.popup.outerWidth();
        var popupLeft = paletteObj.popup.offset().left;

        if (paletteWidth + paletteLeft + 5 < popupWidth + popupLeft) {
          paletteObj.popup.addClass("left-placement");
        }
        if (paletteLeft > popupLeft + 5) {
          paletteObj.popup.addClass("right-placement");
        }
      };

      function createSimplepalette(array) {
        var list = jQuery('<ul class="palette-list">');
        console.log("PALETTE BUILD RUNNING");
        paletteObj.palette = list;

        array.forEach(function (obj, i) {
          var holder = jQuery("<li>");
          var link = jQuery('<a href="#" class="palette-link">');
          var cmyk, rgb, svg_thumb;

          holder.appendTo(list);

          if (!obj.hex) return;

          links = links.add(link);

          link.appendTo(holder);
          svg_thumb = `<svg class="w-100 h-auto palette-thumb" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="58" height="58" rx="3.5" fill="${obj.hex}" stroke="#E5EAED"/>
                    </svg>`;
          link.append(svg_thumb).append(`<span class="visually-hidden">${obj.hex}</span>`);

          rgb = beautyColor(obj.rgb);
          cmyk = beautyColor(obj.cmyk);

          link.on("click", function (e) {
            e.preventDefault();
            links.addClass(classDisabled);
            links.attr("tabindex", -1);
            link.removeClass(classDisabled).addClass(classActive);

            fillPopup(obj.hex, obj.name, obj.pantone, cmyk, rgb);

            popupData.holder.appendTo(holder);
            paletteObj.isOpened = true;
            paletteObj.reposition();
          });
        });
        list.appendTo(palette);
      }

      function createGrouppalette(array) {
        var list = jQuery('<ul class="palette-group">');
        // var list = jQuery('<ul class="palette-group">');

        paletteObj.palette = list;
        array.forEach(function (obj, i) {
          var holder = jQuery("<li>");
          var svgCyclinder;

          holder.appendTo(list);
          if (!obj.group) return;
          svgCyclinder = jQuery(`<svg class="palette-cyclinder" width="160" height="118" viewBox="0 0 160 118" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 44.9536V73.2972C0 84.5655 7.81667 95.8338 23.4333 104.432C54.6667 121.644 105.333 121.644 136.567 104.432C152.183 95.8338 160 84.5655 160 73.2972V44.9536H0Z" fill="${obj.group[2].hex}"/>
                          <mask id="mask-group${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="44" width="160" height="74">
                            <path d="M0 44.9629V73.3064C0 84.5747 7.81667 95.843 23.4333 104.441C54.6667 121.654 105.333 121.654 136.567 104.441C152.183 95.843 160 84.5747 160 73.3064V44.9629H0Z" fill="#C48672"/>
                          </mask>
                          <g mask="url(#mask-group${i})">
                            <path d="M160 44.9629H0V117.371H160V44.9629Z" fill="url(#paint0_linear_group${i})"/>
                          </g>
                          <path d="M80 89.1081C124.183 89.1081 160 69.3836 160 45.0521C160 20.7206 124.183 0.996094 80 0.996094C35.8172 0.996094 0 20.7206 0 45.0521C0 69.3836 35.8172 89.1081 80 89.1081Z" fill="${obj.group[0].hex}"/>
                          <defs>
                          <linearGradient id="paint0_linear_group${i}" x1="0" y1="81.1694" x2="160" y2="81.1694" gradientUnits="userSpaceOnUse">
                          <stop offset="0.5" stop-color="${obj.group[1].hex}"/>
                          <stop offset="1" stop-color="${obj.group[1].hex}" stop-opacity="0"/>
                          </linearGradient>
                          </defs>
                        </svg>`);

          holder.append(svgCyclinder);
          cyclinders = cyclinders.add(svgCyclinder);
          obj.group.forEach(function (item) {
            var link = jQuery('<a href="#" class="palette-link">');
            var linkHolder = jQuery('<div class="palette-link-holder">');
            var cmyk, rgb, svg_thumb;
            links = links.add(link);

            svg_thumb = `<svg width="160" height="60" class="palette-thumb" viewBox="0 0 160 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.00390625" width="160" height="59" rx="4" fill="${item.hex}"/>
                      </svg>`;
            link
              .append(svg_thumb)
              .append(`<span class="visually-hidden">${obj.hex}</span>`)
              .appendTo(linkHolder);
            linkHolder.appendTo(holder);

            rgb = beautyColor(item.rgb);
            cmyk = beautyColor(item.cmyk);

            link.on("click", function (e) {
              e.preventDefault();
              links.addClass(classDisabled);
              links.attr("tabindex", -1);
              link.removeClass(classDisabled).addClass(classActive);
              cyclinders.addClass(classDisabled);
              svgCyclinder.removeClass(classDisabled);

              fillPopup(item.hex, item.name, item.pantone, cmyk, rgb);

              popupData.holder.appendTo(linkHolder);
              paletteObj.isOpened = true;
              paletteObj.reposition();
            });
          });
        });
        list.appendTo(palette);
      }

      function createPopup() {
        var popupTemplate = `<div class="palette-popup card">
                            <svg class="card-img-top  w-100 h-auto" viewBox="0 0 281 119" xmlns="http://www.w3.org/2000/svg">
                              <rect width="281" height="119" fill="#" />
                            </svg>
                            <a class="close" aria-label="Close" href="#"><span class="hidden">close</span><span class="icon-close"></span></a>
                            <div class="card-body">
                              <h3 class="color-name"></h3>
                              <dl class="dl-info info-color">
                              </dl>
                            </div>
                          </div>`;
        var isBusy, timer;

        popupData.holder = jQuery(popupTemplate);
        popupData.rect = popupData.holder.find("rect");
        popupData.close = popupData.holder.find(".close");
        popupData.title = popupData.holder.find(".color-name");
        popupData.info = popupData.holder.find(".info-color");
        popupData.pantone = jQuery("<dd>");
        popupData.pantoneTitle = jQuery("<dt>PMS</dt>");
        popupData.cmyk = jQuery("<dd>");
        popupData.rgb = jQuery("<dd>");
        popupData.hex = jQuery("<dd>");
        popupData.hexLinkCopy = jQuery(
          '<a href="#" data-copy-link-text=""><span class="hidden">copy to clipboard</span></a>'
        );
        popupData.cmykTitle = jQuery("<dt>CMYK</dt>");
        popupData.rgbTitle = jQuery("<dt>RGB</dt>");
        popupData.hexTitle = jQuery("<dt>HEX</dt>");

        popupData.info.append(
          popupData.pantoneTitle,
          popupData.pantone,
          popupData.cmykTitle,
          popupData.cmyk,
          popupData.rgbTitle,
          popupData.rgb,
          popupData.hexTitle,
          popupData.hex
        );

        popupData.hexLinkCopy.appendTo(popupData.hex);
        popupData.holder.appendTo("body");
        popupData.holder.detach();
        popupData.isOpened = false;

        paletteObj.popup = popupData.holder;
        paletteObj.isOpened = false;

        popupData.close.on("click", function (e) {
          e.preventDefault();
          fillPopup();
          links.removeClass([classDisabled, classActive]);
          links.removeAttr("tabindex");
          cyclinders.removeClass(classDisabled);
          popupData.holder.detach();
          paletteObj.isOpened = false;
          clearTimeout(timer);
          popupData.hexLinkCopy.tooltip("hide");
          popupData.hexLinkCopy.tooltip("enable");
        });

        if (typeof popupData.hexLinkCopy.tooltip === "function") {
          popupData.hexLinkCopy.tooltip({
            title: "Copied to clipboard",
            trigger: "click",
          });
        }

        popupData.hexLinkCopy.on("click", function (e) {
          e.preventDefault();
          if (isBusy) return;
          isBusy = true;
          copy(popupData.hexText);
          popupData.hexLinkCopy.tooltip("disable");
        });

        popupData.hexLinkCopy.on("shown.bs.tooltip", function () {
          popupData.hexLinkCopy.focus().blur();
          timer = setTimeout(function () {
            popupData.hexLinkCopy.tooltip("hide");
            popupData.hexLinkCopy.tooltip("enable");
            isBusy = false;
          }, 2000);
        });
      }

      // function fillPopup(hex, name, pantone, cmyk, rgb) {
      //   popupData.rect.attr("fill", hex);
      //   popupData.title.text(name);
      //   if (pantone) {
      //     popupData.pantoneTitle.show();
      //     popupData.pantone.text(pantone).show();
      //   } else {
      //     popupData.pantoneTitle.hide();
      //     popupData.pantone.hide();
      //   }
      //   popupData.cmyk.text(cmyk);
      //   popupData.rgb.text(rgb);
      //   popupData.hexLinkCopy.text(hex);
      //   popupData.hexText = hex;
      // }

      //UPDATED 4/7/2025 to address if values are missing to remove the value label 
      function fillPopup(hex, name, pantone, cmyk, rgb) {
        popupData.rect.attr("fill", hex);
        popupData.title.text(name);

        // Pantone
        if (pantone) {
          popupData.pantoneTitle.show();
          popupData.pantone.text(pantone).show();
        } else {
          popupData.pantoneTitle.hide();
          popupData.pantone.hide();
        }

        // CMYK
        if (cmyk && cmyk !== "N/A") {
          popupData.cmykTitle.show();
          popupData.cmyk.text(cmyk).show();
        } else {
          popupData.cmykTitle.hide();
          popupData.cmyk.hide();
        }

        // RGB
        if (rgb && rgb !== "N/A") {
          popupData.rgbTitle.show();
          popupData.rgb.text(rgb).show();
        } else {
          popupData.rgbTitle.hide();
          popupData.rgb.hide();
        }

        // HEX (with copy link)
        if (hex && hex !== "N/A") {
          popupData.hexTitle.show();
          popupData.hex.empty().append(popupData.hexLinkCopy);
          popupData.hexLinkCopy.text(hex).show();
          popupData.hex.show();
        } else {
          popupData.hexTitle.hide();
          popupData.hex.hide();
          popupData.hexLinkCopy.hide();
        }

        popupData.hexText = hex;
      }


      if (!jsonVar) return;

      // jQuery.ajax({
      //   type: "GET",
      //   url: url,
      //   data: "JSON",
      //   success: function (response) {
      //     createPopup();
      //     if(type === 'simple') {
      //       createSimplepalette(response);
      //     } else if(type === 'group') {
      //       createGrouppalette(response)
      //     }
      //   },
      //   error: function() {
      //     console.log('error')
      //   }
      // });

      createPopup();
      console.log("JSON HTML:", JSON.stringify(eval(jsonVar)));
      var jsonData = JSON.parse(JSON.stringify(eval(jsonVar)));
      console.log(jsonData, "JSON DATA");
      if (type === "simple") {
        createSimplepalette(jsonData);
      } else if (type === "group") {
        createGrouppalette(jsonData);
      }

      // push to array for resize window
      popupArray.push(paletteObj);
    });

    win.on("resize orientationchange", function () {
      if (!resizeFlag) {
        resizeFlag = true;
      }
      clearTimeout(timer);
      timer = setTimeout(function () {
        resizeFlag = false;
        popupArray.forEach(function (obj) {
          if (obj.isOpened) {
            obj.reposition();
          }
        });
      }, 500);
    });
  }

  function initSlickCarousel() {
    jQuery(".tabset-slick-slider").slick({
      slidesToScroll: 1,
      rows: 0,
      arrows: false,
      infinite: false,
      variableWidth: true,
      draggable: false,
    });
  }

  function initTBTabs() {
    jQuery(".nav-tabs").each(function () {
      var tabset = jQuery(this);
      var buttons = tabset.find('button[data-bs-toggle="tab"]');

      buttons.on("shown.bs.tab", function () {
        initSmoothScroll();
      });
    });
  }

  function initCopyToClipboard() {
    var activeClass = "active";
    jQuery(".scrollspy-section .address-copy").each(function (index, value) {
      var copyHolder = jQuery(this);
      var btnCopy = copyHolder.find("a");
      var address =
        location.protocol +
        "//" +
        location.host +
        location.pathname +
        "#" +
        copyHolder.find("h2").attr("id");
      var tooltip = Tooltip.getInstance(btnCopy);

      jQuery(btnCopy).attr("data-address", address);

      btnCopy.on("click", function (e) {
        e.preventDefault();
        var textCopy = jQuery(this).attr("data-address");
        copy(textCopy);
        copyHolder.addClass(activeClass);
        tooltip.show();
        setTimeout(function () {
          tooltip.hide();
          copyHolder.removeClass(activeClass);
        }, 5000);
      });
    });

    jQuery("[data-copy-link-text]").each(function () {
      var link = jQuery(this);
      var copyText = link.data("copy-link-text");
      var isBusy;

      if (typeof link.tooltip === "function") {
        link.tooltip({
          title: "Copied to clipboard",
          trigger: "click",
        });
      }

      link.on("click", function (e) {
        e.preventDefault();
        if (isBusy) return;
        isBusy = true;
        copy(copyText, e.target);
        // link.tooltip('show');
        link.tooltip("disable");
      });
      link.on("shown.bs.tooltip", function () {
        link.focus().blur();
        setTimeout(function () {
          link.tooltip("hide");
          link.tooltip("enable");
          isBusy = false;
        }, 2000);
      });
    });

    function copy(text, focusTarget) {
      var input = document.createElement("input");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      var focused = focusTarget;
      input.select();
      var result = document.execCommand("copy");
      if (focused) {
        focused.focus();
      }
      document.body.removeChild(input);
      return result;
    }
  }

  function initSmoothScroll() {
    jQuery(".navbar-aside").each(function () {
      var asideMenu = jQuery(this);
      var lastId,
        topMenu = $(".header"),
        topMenuHeight = topMenu.outerHeight(),
        menuItems = asideMenu.find('ul:not(.sticksy-dummy-node) a[href^="#"]:not([href="#"])'),
        scrollItems = menuItems.map(function () {
          var item = $($(this).attr("href"));

          if (item.width() <= 0) {
            item = $($(this).attr("data-href"));
          }

          if (item.length) {
            return item;
          }
        });

      menuItems.click(function (e) {
        var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1 - 112;

        if ($(href).width() <= 0) {
          href = $(this).attr("data-href");
          offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1 - 112;
        }

        //html smooth scroll animation
        // $("html, body").stop().animate(
        //   {
        //     scrollTop: offsetTop,
        //   },
        //   300
        // );
        // e.preventDefault();
      });

      // if (window.location.hash && window.location.hash.length) {
      //   setTimeout(function(){
      //     $('html, body').stop().animate({
      //         scrollTop: $(window.location.hash).offset().top-topMenuHeight+1-112
      //     }, 300);
      //   }, 150);
      // }

      // window.addEventListener(
      //   "hashchange",
      //   function () {
      //     //html smooth scroll animation
      //     $("html, body")
      //       .stop()
      //       .animate(
      //         {
      //           scrollTop: $(window.location.hash).offset().top - topMenuHeight + 1 - 112,
      //         },
      //         300
      //       );
      //   },
      //   false
      // );

      $(window).scroll(function () {
        var fromTop = $(this).scrollTop() + topMenuHeight + 112;
        scrollItems = menuItems.map(function () {
          var item = $($(this).attr("href"));

          if (item.width() <= 0) {
            item = $($(this).attr("data-href"));
          }

          if (item.length) {
            return item;
          }
        });

        var cur = scrollItems.map(function () {
          if ($(this).offset().top < fromTop) return this;
        });
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        //  console.log(cur, id);

        if (lastId !== id) {
          var location = window.location.toString().split("#")[0];

          //COMMENTING OUT FOR ADA TESTING
          //history.replaceState(null, null, location + "#" + id);
          lastId = id;

          if (jQuery("[href='#" + id + "']").length) {
            menuItems
              .parent()
              .removeClass("active")
              .end()
              .filter("[href='#" + id + "']")
              .parent()
              .addClass("active");
          } else {
            menuItems
              .parent()
              .removeClass("active")
              .end()
              .filter("[data-href='#" + id + "']")
              .parent()
              .addClass("active");
          }
        }
      });
    });

    jQuery(".next-section-link").each(function () {
      var btnNextSection = jQuery(this);
      var lastId,
        topMenu = $(".header"),
        topMenuHeight = topMenu.outerHeight();

      btnNextSection.click(function (e) {
        var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;

        //html smooth scroll animation
        // $("html, body").stop().animate(
        //   {
        //     scrollTop: offsetTop,
        //   },
        //   300
        // );
        // e.preventDefault();
      });
    });
    // console.log("FOCUSED:", "*:focus");
  }

  function initStickyAside() {
    if (jQuery(".sticky-aside") && jQuery(".sticky-aside").length) {
      var win = jQuery(window);
      var stickyEl = new Sticksy(".sticky-aside", {
        topSpacing: jQuery(".header.fixed-top").outerHeight() + 118,
        listen: true,
      });

      resizeHandler();
      win.on("resize orientationchange", resizeHandler);

      function resizeHandler() {
        if (win.width() < 1024) {
          stickyEl.disable();
          stickyEl.refresh();
        } else {
          stickyEl.enable();
          stickyEl.refresh();
        }
      }
    }
  }

  function initSerchAccessibility() {
    var searchDropdown = jQuery(".navbar.dropdown");
    var searchDropdownToggle = searchDropdown.find('[data-bs-target="#searchDropdown"]');
    var firstFocusedItem = searchDropdown.find("#searchDropdown [tabindex]").eq(0);

    if (searchDropdown && searchDropdown.length) {
      searchDropdown.on("shown.bs.collapse", function () {
        firstFocusedItem.focus();
        document.addEventListener("focusin.searchDropdownOpen", null);
      });

      searchDropdown.on("hide.bs.collapse", function () {
        searchDropdownToggle.focus();
        document.removeEventListener("focusin.searchDropdownOpen", null);
      });

      jQuery(document).on("focusin.searchDropdownOpen", function (e) {
        if (jQuery(e.target).closest("#searchDropdown").length <= 0) {
          firstFocusedItem.focus();
        }
      });
    }
  }

  function initAlert() {
    jQuery("[data-alert-holder]").each(function () {
      var alertHolder = jQuery(this);
      var btnClose = alertHolder.find("[data-alert-close]");

      btnClose.on("click", function (e) {
        e.preventDefault();
        alertHolder.css("display", "none");
      });
    });
  }

  function initRememberMe() {
    jQuery(".login-form").each(function () {
      var loginForm = jQuery(this);
      var emailInput = loginForm.find('input[type="email"]');
      var passInput = loginForm.find('input[type="password"]');
      var rememberCheckbox = loginForm.find("[data-remember-check]");

      if (localStorage.checkBoxValidation && localStorage.checkBoxValidation != "") {
        rememberCheckbox.attr("checked", "checked");
        emailInput.val(localStorage.userName);
        passInput.val(localStorage.password);
      } else {
        rememberCheckbox.removeAttr("checked");
        emailInput.val("");
        passInput.val("");
      }

      loginForm.on("submit", function () {
        if (rememberCheckbox.is(":checked")) {
          localStorage.userName = emailInput.val();
          localStorage.password = passInput.val();
          localStorage.checkBoxValidation = "remember";
        } else {
          localStorage.userName = "";
          localStorage.password = "";
          localStorage.checkBoxValidation = "";
        }
      });
    });
  }
})(jQuery, Drupal, once, Tooltip);
